import { never } from '@common/utils/never';

export interface IGraphSizes {
    largestX: number;
    largestY: number;
    margin: number;
    nodeHeight: number;
    nodeWidth: number;
    smallestX: number;
    smallestY: number;
}

export interface IPosition {
    offset?: number;
    x: number;
    y: number;
}

export function getCoordinates(position: IPosition, sizes: IGraphSizes) {
    const x =
        sizes.margin / 2 +
        (position.x - sizes.smallestX) * (sizes.nodeWidth + sizes.margin) +
        ((position.offset || 0) * sizes.nodeWidth) / 10;
    const y =
        sizes.margin / 2 +
        (position.y - sizes.smallestY) * (sizes.nodeHeight + sizes.margin) +
        ((position.offset || 0) * sizes.nodeHeight) / 10;

    return { x, y };
}

export const allColors = [
    'white',
    'azure',
    'black',
    'green',
    'lightgreen',
    'red',
    'lightgrey',
    'grey',
    'purple',
    'orange',
    'blue',
    'lightblue',
    'yellow',
    'lightyellow',
] as const;
export type Color = (typeof allColors)[number];

export function getColorCode(color: Color) {
    switch (color) {
        case 'white':
            return '#FAFAFA';
        case 'azure':
            return '#55bbb8';
        case 'black':
            return '#322A24';
        case 'red':
            return '#EE1111';
        case 'lightgreen':
            return '#80cb74';
        case 'green':
            return '#41CF2B';
        case 'lightgrey':
            return '#e0e0e0';
        case 'grey':
            return '#CCCCCC';
        case 'purple':
            return '#FF37F0';
        case 'orange':
            return '#FF9A1E';
        case 'blue':
            return '#3C3CFF';
        case 'lightblue':
            return '#E0E8FF';
        case 'lightyellow':
            return '#EFF21D';
        case 'yellow':
            return '#EFF19d';
        default:
            never(color);
    }
}
